exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Onboarding-2854e910{background:#ebebeb;font-family:\"aktiv-grotesk\",\"Aktiv Grotesk\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;text-align:center;color:#666;padding:15px 60px 20px 60px;position:fixed;bottom:0;left:0;right:0;z-index:99}.tipTitle-b11d765b{font-size:20px}.next-9155304b{position:absolute;right:30px;top:calc(50% - 20px)}.prev-860b7087{position:absolute;left:30px;top:calc(50% - 20px)}.next-9155304b,.prev-860b7087{transition:color 0.1s ease}.next-9155304b:hover,.prev-860b7087:hover{color:#333;cursor:pointer}.dismiss-f1ab396b{position:absolute;top:10px;right:10px}.dismissText-ba042964{font-size:12px;margin-top:30px;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"Onboarding": "Onboarding-2854e910",
	"tipTitle": "tipTitle-b11d765b",
	"next": "next-9155304b",
	"prev": "prev-860b7087",
	"dismiss": "dismiss-f1ab396b",
	"dismissText": "dismissText-ba042964"
};